module.exports = __webpack_public_path__ + "static/media/service3.701a8c14.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Services/images/service3.png
// module id = 437
// module chunks = 0